import { IconsProps } from './IconsProps';

const GoogleLogoShort = ({
  className = '',
  onClick,
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <path
        d="M15.8299 8.17984C15.8299 7.65317 15.7833 7.15317 15.7033 6.6665H8.16992V9.67317H12.4833C12.2899 10.6598 11.7233 11.4932 10.8833 12.0598V14.0598H13.4566C14.9633 12.6665 15.8299 10.6132 15.8299 8.17984Z"
        fill="#4285F4"
      />
      <path
        d="M8.17003 16.0002C10.33 16.0002 12.1367 15.2802 13.4567 14.0602L10.8834 12.0602C10.1634 12.5402 9.25003 12.8335 8.17003 12.8335C6.08336 12.8335 4.3167 11.4269 3.68336 9.52686H1.03003V11.5869C2.34336 14.2002 5.04336 16.0002 8.17003 16.0002Z"
        fill="#34A853"
      />
      <path
        d="M3.68326 9.52691C3.51659 9.04691 3.42992 8.53357 3.42992 8.00024C3.42992 7.46691 3.52326 6.95357 3.68326 6.47357V4.41357H1.02992C0.483255 5.49357 0.169922 6.70691 0.169922 8.00024C0.169922 9.29357 0.483255 10.5069 1.02992 11.5869L3.68326 9.52691Z"
        fill="#FBBC05"
      />
      <path
        d="M8.17003 3.16667C9.35003 3.16667 10.4034 3.57334 11.2367 4.36667L13.5167 2.08667C12.1367 0.793334 10.33 0 8.17003 0C5.04336 0 2.34336 1.8 1.03003 4.41334L3.68336 6.47334C4.3167 4.57334 6.08336 3.16667 8.17003 3.16667Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export default GoogleLogoShort;
